import * as React from "react";
import { Button } from "antd";
import {useHistory} from "react-router-dom";

export const ProfileButton = ({i18n, lang}) => {
    const history = useHistory();
return <Button disabled={false} onClick={() => history.push("/dashboard/profile")}>{i18n[lang].Profile}</Button> 
}